module.exports = __webpack_public_path__ + "img/redbg_behind@2x.1d7212b4.png";